import {useEffect, useMemo} from 'react';

import {useDNT} from '@salesforce/commerce-sdk-react';
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site';

import {syncGtmConsentFromDnt} from '@amblique/king-living/app/utils/gtm-consent';
import {getGtmConfigFromSite} from '@amblique/king-living/app/utils/gtm-utils';

const GtmPageView = () => {
  const {site} = useMultiSite();
  const {selectedDnt} = useDNT();
  const gtmConfig = useMemo(() => getGtmConfigFromSite(site), [site]);

  useEffect(() => {
    syncGtmConsentFromDnt(selectedDnt, gtmConfig.enabled, site?.id);
  }, [gtmConfig.enabled, selectedDnt, site?.id]);

  return null;
};

GtmPageView.displayName = 'GtmPageView';

export default GtmPageView;
